(function (angular) {
	'use strict';

	angular
		.module('staticChartModule')
		.factory('StaticChartService', [
			'$http',
			'$q',
			'HIGHCHARTS_SERIES_COLORS',
			StaticChartServiceFunction
		]);

	function StaticChartServiceFunction(
		$http,
		$q,
		HIGHCHARTS_SERIES_COLORS) {

		var factory = {
			fetchChartInfo: fetchChartInfo
		};

		function fetchChartInfo(chartUrl) {
			var deferred = $q.defer();

			$http.get(chartUrl)
				.then(function(response) {
					angular.forEach(response.data.highchartsObject.series, function(series, index) {
						if(!angular.isDefined(series.color)) {
							series.color = HIGHCHARTS_SERIES_COLORS[index];
						}

						if(series.dataFormat === 'datetime') {
							angular.forEach(series.data, function(point) {
								point.x = new Date(point.x);
							});					
						}
					});

					deferred.resolve(response);
				});

			return deferred.promise;
		}

		return factory;
	}
})(window.angular);